import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
//import { Test } from './TrackReruleDetails.styles';
import styled from "styled-components";

export const Wrapper = styled.section`
  margin-top: -10px;
  margin-bottom: 10px;
`;

const TrackReruleDetails = ({ loading, track }) => {
  return (
    (!loading && track.rerule > 0 && (
      <Wrapper>
        <div className="totd-rerule">
          <Link to={`/${track.rerule}`}>Originally posted</Link> by {track.reruleChim.full_name} back in {track.reruleChim.rerule_date}
        </div>
      </Wrapper>
    )) ||
    null
  );
};

TrackReruleDetails.propTypes = {
  // bla: PropTypes.string,
};

TrackReruleDetails.defaultProps = {
  // bla: 'test',
};

export default TrackReruleDetails;
